<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  name: "ListeDeCoursesSupprimerProduit",
  components: { Popin, Icon, Badge, Button, Titre, StateOverlay },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isProduitsHabituels: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["confirmDelete"],
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    aria-label="Supprimer de la liste"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <StateOverlay
      overlay
      :is-loading="isLoading"
    >
      <div class="u-text-center">
        <Badge
          variant="white"
          circle
          size="xlg"
        >
          <Icon
            name="alert-circle"
            variant="primary"
            size="lg"
          />
        </Badge>
        <Titre
          tag="h1"
          variant="primary"
          size="md"
          class="u-mt-xs u-mb-md"
        >
          Supprimer de la liste
        </Titre>
        <p class="u-font-14 u-mb-md u-pl-lg u-pr-lg">
          Êtes-vous sûr(e) de vouloir supprimer ce ou ces produits de votre liste {{ isProduitsHabituels ? "de produits habituels" : "de courses" }} ?
        </p>
        <p
          v-if="isProduitsHabituels"
          class="u-font-14 u-mb-md u-pl-lg u-pr-lg"
        >
          À noter que si vous achetez ce produit une nouvelle fois, il sera de nouveau visible dans cette liste.
        </p>
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="$emit('confirmDelete')"
        >
          Oui je supprime
        </Button>
      </div>
    </StateOverlay>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
